<!-- eslint-disable vue/require-v-for-key -->
<template>
<div id='building' style="font-family: Times New Roman;">
  
            <!-- <span id="busuanzi_container_site_pv">本站总访问量<span id="busuanzi_value_site_pv"></span>次</span> -->


  <div class="content">
    <el-row>
    <el-col  >
      <el-card class="box-card" shadow="always">
        <div style="text-align:center!important">
          <h1>MoEController: Instruction-based Arbitrary Image Manipulation with Mixture-of-Expert Controllers</h1>
        </div>
       
        <el-row type="flex" class="row-bg" justify="center" style="font-size: medium;text-align:center">
          <el-col :span="5"  >
            <p><strong>Sijia Li</strong></p>
            <p>OPPO Research Institute</p>
            <p>lisijia@oppo.com</p>
          </el-col>
          <el-col :span="5"  >
            <p><strong>Chen Chen</strong></p>
            <p> OPPO Research Institute</p>
            <p>chenchen4@oppo.com</p>
          </el-col>
          <el-col :span="5">
            <p><strong>Haonan Lu</strong></p>
            <p>OPPO Research Institute</p>
            <p>luhaonan@oppo.com</p>
          </el-col>

        </el-row>
       
        <el-row type="flex" class="row-bg" justify="center" style="text-align:center">
          <el-col :span="4">
            <!-- <a href="#" target="_blank" style="font-size:30px;color: #224b8d;">Paper</a> -->
            <el-button type="primary" icon="el-icon-document" @click="paperClick" class="code-paper-button">Paper</el-button>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" class="code-paper-button">
              <template>
                <svg t="1694072246114" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1023" width="14" height="14"><path d="M511.957333 21.333333C241.024 21.333333 21.333333 240.981333 21.333333 512c0 216.832 140.544 400.725333 335.573334 465.664 24.490667 4.394667 32.256-10.069333 32.256-23.082667 0-11.690667 0.256-44.245333 0-85.205333-136.448 29.610667-164.736-64.64-164.736-64.64-22.314667-56.704-54.4-71.765333-54.4-71.765333-44.586667-30.464 3.285333-29.824 3.285333-29.824 49.194667 3.413333 75.178667 50.517333 75.178667 50.517333 43.776 75.008 114.816 53.333333 142.762666 40.789333 4.522667-31.658667 17.152-53.376 31.189334-65.536-108.970667-12.458667-223.488-54.485333-223.488-242.602666 0-53.546667 19.114667-97.322667 50.517333-131.669334-5.034667-12.330667-21.930667-62.293333 4.778667-129.834666 0 0 41.258667-13.184 134.912 50.346666a469.802667 469.802667 0 0 1 122.88-16.554666c41.642667 0.213333 83.626667 5.632 122.88 16.554666 93.653333-63.488 134.784-50.346667 134.784-50.346666 26.752 67.541333 9.898667 117.504 4.864 129.834666 31.402667 34.346667 50.474667 78.122667 50.474666 131.669334 0 188.586667-114.730667 230.016-224.042666 242.090666 17.578667 15.232 33.578667 44.672 33.578666 90.453334v135.850666c0 13.141333 7.936 27.605333 32.853334 22.869334C862.250667 912.597333 1002.666667 728.746667 1002.666667 512 1002.666667 240.981333 783.018667 21.333333 511.957333 21.333333z" p-id="1024" fill="#ffffff"></path></svg>
                <span style="margin-left: 5px;">Code coming soon</span>
              </template>
</el-button>
            <!-- <div style="font-size:30px;">Code <span style="font-size:16px;">(Coming Soon)</span></div> -->
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center" style="margin-top: 40px;">
          <el-image :src="require('../assets/show_pics/p1-1.png')"  fit="fill"></el-image>
        </el-row>
      </el-card>

    </el-col>
  </el-row>
  </div>
  <div class="content">
    <el-row>
    <el-col>
      <el-card class="box-card"  shadow="always">
        <el-row type="flex" class="row-bg" justify="center">
          <h1>Abstract </h1>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-col >
            <div style="font-size:24px;">
              Recently, text-guided image generation by diffusion models has made astonishing progress, achieving exciting effects in open-domain image manipulation tasks. However, due to the complexity and diversity of image manipulations, few models currently possess comprehensive zero-shot abilities for both global and local image editing. In this work, we propose a method with a mixture-of-expert controllers to align the text-guided capacity of diffusion models with different kinds of human instructions, enabling our model to handle various open-domain image manipulation tasks with natural language instructions. First, in addition to the instruction-based image editing dataset, we employ the generative capabilities of large language models (Chatgpt) and conditional image synthesis models (ControlNet) to build a large number of global image transfer datasets. Then, to adapt to different image manipulation tasks, we use a mixture-of-expert technique for ability adaptation. Our conditional diffusion model undergoes task-specific adaptation training on a comprehensive dataset and can achieve global and local image editing capabilities during the inference phase without additional fine-tuning. Extensive experiments demonstrate that our method achieves surprisingly good performance on various image manipulation tasks with open-domain images and human instructions.
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
  </div>
  
  <div class="content">
    <el-row>
    <el-col  >
      <el-card class="box-card" shadow="always">
        <el-row type="flex" class="row-bg" justify="center">
          <h1>More Results </h1>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <h2>Style transfer</h2>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-image :src="require('../assets/show_pics/p1.png')" fit="fill"></el-image>
        </el-row>
        <!-- <el-row type="flex" class="row-bg" justify="center" style="margin-top: 40px;">
          <el-image :src="require('../assets/show_pics/p10-0.png')" fit="fill"></el-image>
        </el-row> -->
        <el-row type="flex" class="row-bg" justify="center" style="margin-top: 40px;">
          <div>
            <el-image :src="require('../assets/show_pics/P2-1.png')" fit="fill"></el-image>
            <el-image :src="require('../assets/show_pics/P2-2.png')" fit="fill"></el-image>
          </div>

        </el-row>
        <el-row type="flex" class="row-bg" justify="center" style="margin-top: 40px;">

        </el-row>
        <!-- <el-row type="flex" class="row-bg" justify="center" style="margin-top: 40px;">
          <el-image :src="require('../assets/show_pics/p11.png')" fit="fill"></el-image>
        </el-row> -->
        <el-row type="flex" class="row-bg" justify="center">
          <h2>Background changing</h2>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-image :src="require('../assets/show_pics/p2.png')" fit="fill"></el-image>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center" style="margin-top: 40px;">
          <el-image :src="require('../assets/show_pics/p3.png')" fit="fill"></el-image>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center" style="margin-top: 40px;">
          <h2>Local editing</h2>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-image :src="require('../assets/show_pics/p5.png')" fit="fill"></el-image>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <h2>Entity swapping</h2>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-image :src="require('../assets/show_pics/p4.png')" fit="fill"></el-image>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <h2>Attribute swapping</h2>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-image :src="require('../assets/show_pics/p6.png')" fit="fill"></el-image>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
  </div>
  
  <div class="content">
    <el-row>
    <el-col  >
      <el-card class="box-card"  shadow="always">
        <el-row type="flex" class="row-bg" justify="center" >
          <h1>Approach</h1>
        </el-row>
        <el-row type="flex" class="row-bg" justify="left" >
          <h2>Pipeline of dataset construction.</h2>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-col >
            <div style="font-size:24px;">
              a)  Input the original image caption and reference examples to ChatGPT and, combined with different instructions and in-context examples, generate corresponding target image captions that conform to the original image caption.  <br/>
              b) We feed the ControlNet model with the aforementioned generated text data to produce pairwise global manipulation images. <br/>
              c) We screen the text image quality using a variety of filtering conditions, including image resolutions, aesthetic scores, and CLIP scores, and build a comprehensive global manipulation dataset for model learning.
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-image :src="require('../assets/show_pics/m1.png')" fit="fill"></el-image>
        </el-row>
        <el-row type="flex" class="row-bg" justify="left" >
          <h2>MOE controller structure.</h2>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-col >
            <div style="font-size:24px;">
              d) We add expert models with different abilities and a gated system after the text encoder to automatically adapt to different image manipulation tasks. In addition, we
              add a reconstruction loss related to the original image during the training phase.
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-image :src="require('../assets/show_pics/m2-1.png')" fit="fill"></el-image>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
  </div>

  <!-- <div class="content">
    <el-row>
    <el-col  >
      <el-card class="box-card"  shadow="always">
        <el-row type="flex" class="row-bg" justify="center" >
          <h1>Citation</h1>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
  </div> -->

  <div class="busuanzi">
    <el-row type="flex" class="row-bg" justify="center">
      <span id="busuanzi_container_site_pv" style="display:none">
        本站总访问量
        <span id="busuanzi_value_site_pv"></span>次
        <span class="post-meta-divider">|</span>
      </span>
      <span id="busuanzi_container_site_uv" style="display:none">
        本站访客数
        <span id="busuanzi_value_site_uv"></span>人
      </span>
    </el-row>
    </div>
    
  </div>
  
</template>
<script scoped>
import 'viewerjs/dist/viewer.css'
import axios from "axios";
export default {
  name: 'showEntity',
  props: {
    msg: String
  },
  components:{
  },
  data() {
        return {
            //是否根据容器尺寸自动计算重绘
            autoResize:true,
            //是否始终填满容器
            fillBox: false,
            //列宽-有指定列数则此属性失效
            // colWidth: window.innerWidth / 50,
            //列数
            col: 6,
          imgsArr:[
          ],
          imgsArrDisplay:[
          ],
          Options: { "inline": false, "button": true, "navbar": false, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": false, "keyboard": true,
          "url": "data-source",
          },
          viewer:'',
          swiperImageList1:[
        ],
          swiperShow:false,
          tittleText:'',
          labelDisplay:true,
          selectTab:"4",
          inputQuery:"熊猫在吃竹子",
          options: [{
            value: "2",
            label: '主题'
          }, {
            value: "4",
            label: '壁纸'
          }, {
            value: "12",
            label: '动态壁纸'
          }, {
            value: "10",
            label: '视频铃声'
          }],
          loading:false,
          componentKey: 0,
          sliceIndex:0,
          imgPart1:[],
          imgPart2:[],
          imgEN0:[],
          imgEN1:[],
          infoMap:{
            "一辆汽车的侧面贴着“速度”":"\"Speed\" is pasted on the side of a car",
            "图书馆墙壁上贴着“请勿涂鸦”的标语":"There are slogans on the walls of the library that say \"No Graffiti\"",
            "“秋天来了”写在漂浮在湖面上的秋叶上":"\"Autumn Comes\" is written on autumn leaves floating on the lake",
            "一个手绘的菠萝形状的木制“菠萝俱乐部”标志，悬挂在酒吧外":"A hand-painted wooden \"Pineapple Club\" logo in the shape of a pineapple hung outside the bar",
            "一个红包,写了“新春快乐”的祝福":"A red envelope with the blessing of \"Happy New Year\"",
            "一件t恤，上面写着“没有行星”":"A T-shirt that says \"No Planet\"",
            "一只猫在读一本书，书的标题是“捉鼠大法”":"A cat is reading a book entitled \"The Great Method of Catching Rats\"",
            "一只猫在读一本书，标题是“捉鼠大法”":"A cat is reading a book entitled \"The Great Method of Catching Rats\"",
            "一辆车上写着“速度”的标语":"A car has a slogan with \"speed\" written on it",
            "书店里贴了“请勿涂鸦”的告示":"A notice \"No Graffiti\" was posted in the bookstore",
            "书店里贴了“请勿涂鸦”的告示 ":"A notice \"No Graffiti\" was posted in the bookstore",
            "图书馆里挂着“勿扰”的门牌":"There is a \"Don't Disturb\" sign hanging in the library",
            "在停车场里，一张写着“禁止停车”的牌子":"In the parking lot, a sign says \"No Parking\"",
            "在医院里，一张写着“请勿打扰”的牌子":"In the hospital, a sign says \"Don't Disturb\"",
            "在博物馆里，一块写着“禁止用闪光灯”的标牌":"In the museum, a sign says \"No Flashing\"",
            "博物馆里，展柜里有一个标记为“月亮岩”的标志":"In the museum, there is a sign labeled \"Moon Rock\" in the display cabinet",
            "在图书馆，一张写着“请勿喧哗”的标牌":"In the library, there is a sign that says \"No Noise\"",
            "在展览馆里，一张写着“请勿触摸”的标牌":"In the exhibition hall, a sign says \"Do Not Touch\"",
            "在火车站，一张写着“请排队购票”的牌子":"At the railway station, there is a sign saying \"Please queue up to buy tickets\"",
            "在火车站，一张写着“请排队购票”的牌子 ":"At the railway station, there is a sign saying \"Please queue up to buy tickets\"",
            "在超市里，一张写着“请勿触摸”的标识":"In a supermarket, a sign says \"Do Not Touch\"",
            "在音乐会现场，“摇滚”字样":"At the concert site, the words \"rock\"",
            "小乌龟举着牌子，上面显示“我要爬山”":"The little turtle held up a sign that said, \"I want to climb the mountain.\"",
            "小乌龟举着牌子，上面显示“我要爬山” ":"The little turtle held up a sign that said, \"I want to climb the mountain.\"",
            "小乌龟举着牌子，显示“我要爬山”  ":"The little turtle held up a sign that said, \"I want to climb the mountain.\"",
            "小乌龟举着牌子，显示“我要爬山”":"The little turtle held up a sign that said, \"I want to climb the mountain.\"",
            "小松鼠举着牌子，上面显示“我要储存粮食”":"The little squirrel held up a sign that said, \"I want to store grain.\"",
            "小浣熊拿着牌子,“我要学习”":"The little raccoon held the sign and said, \"I want to learn.\"",
            "小浣熊杯子上印着“浣”":"\"Huan\" is printed on the little raccoon cup",
            "小浣熊盯着“深度学习”思考着未来":"Little Raccoon Stares at \"Deep Learning\" Thinking about the Future",
            "小海豚举着牌子，上面显示“我要游泳”":"The little dolphin held up a sign that said, \"I want to swim.\"",
            "小狐狸举着牌子，上面写着“我要食物”":"The little fox held up a sign that said, \"I want food.\"",
            "小猫咪举着牌子，上面显示“我要吃鱼”":"Kitty holds up a sign that says \"I want to eat fish\"",
            "小猫咪举着牌子，上面显示“我要吃鱼”。":"The kitten held up a sign that said, \"I want to eat fish.\".",
            "小猴子举着牌子，上面写着“我要果子”":"The little monkey held up a sign that said, \"I want fruit.\"",
            "小蜜蜂举着牌子，上面显示“我要采花”":"The little bee held up a sign that said, \"I want to pick flowers.\"",
            "小鹿举着牌子，上面显示“我要奔跑”":"The deer held up a sign that said, \"I want to run.\"",
            "校园里，一块写着“禁止乱扔垃圾”的标语":"On campus, a sign reads \"No Littering\"",
            "桌子上有本书，标题是“花园里的女孩”":"There is a book on the table entitled \"The Girl in the Garden\"",
            "海边有一个刻着“北戴河”的石碑":"There is a stone tablet engraved with \"Beidaihe\" on the seashore",
            "草地上贴着“禁止踩踏”的标识":"\"No Treading\" signs are pasted on the grass",
            "街边的路牌，内容显示“天道酬勤”":"A street sign displaying \"Heavenly Way Rewards Diligence\"",
            "课堂上，黑板上写着“知识改变命运”这句话":"In class, the sentence \"knowledge changes fate\" is written on the blackboard",
            "赌场门口挂着“拒绝赌博”的禁止牌":"There is a \"No Gambling\" sign hanging outside the casino",
            "这个垃圾桶上写着“环境保护”的字样":"The words \"environmental protection\" are written on this trash can",
            "这个旅行箱上写着“轻松出行”的字样":"The words \"Easy Travel\" are written on this suitcase",
            "这本书上写着“智慧启迪”的标语":"The book has a slogan \"Wisdom and Enlightenment\" written on it",
            "酒店里贴着“请勿打扰”的门牌":"There is a \"Do Not Disturb\" sign posted in the hotel",
            "饭盒上写了“健康饮食”的字样":"The words \"healthy eating\" are written on the lunch box",
            "No Picnics_ signs hang in the park73":"\"No Picnics_ signs hang in the park",
            "Safety First_ slogan printed on school bus308":"\"Safety First_ slogan printed on school bus",
            "A _No Smoking_ sign is placed in the hotel514":"A _No Smoking_ sign is placed in the hotel",
            "a close up of a figurine of toothpaste tube, a 3D render, candy pastel, with text _brush your teeth_ on the tube107":"a close up of a figurine of toothpaste tube, a 3D render, candy pastel, with text _brush your teeth_ on the tube",
            "A hand painted wooden _Pineapple Club_ sign in the shape of a pineapple, hanging outside a bar":"A hand painted wooden _Pineapple Club_ sign in the shape of a pineapple, hanging outside a bar",
            "Kitten holding a sign that reads _I want fish_8":"Kitten holding a sign that reads _I want fish_",
            "Little raccoon holding a sign that reads _I want to learn_225":"Little raccoon holding a sign that reads _I want to learn_",
            "Photo of the restaurant _Gas Station_432":"Photo of the restaurant _Gas Station_",
            "Play Fair Play_ sign on golf course326":"\"Play Fair Play_ sign on golf course",
            "a 3d model of a 1980s-style computer with the text _my old habit_ on the screen85":"a 3d model of a 1980s-style computer with the text _my old habit_ on the screen",
            "A brain sculpture made of wire and paper with _deep thoughts_ written in brain material345":"A brain sculpture made of wire and paper with _deep thoughts_ written into the material of the brain",
            "A photographer wears a t-shirt with the word _Lens_ printed on it258":"A photographer wears a t-shirt with the word _Lens_ printed on it",
            "A pink bottle that says _LOVE_220":"A pink bottle that says _LOVE_",
            "a sign that reads _no dogs_ but with a dog smiling and wagging its tail1":"a sign that reads _no dogs_ but with a dog smiling and wagging its tail",
            "A t-shirt with the message _There is no planet B_ written on it":"A t-shirt with the message _There is no planet B_ written on it.",
            "A vintage image of the Las Vegas Strip with the words _Las Vegas_ in bold print131":"A vintage image of the Las Vegas Strip with the words _Las Vegas_ in bold print",
            "An antique bottle labeled _Energy Tonic_":"An antique bottle labeled _Energy Tonic_.",
            "Bananas arranged on a picnic table to form the message _That’s bananas_120":"Bananas arranged on a picnic table to form the message _That’s bananas!_",
            "Little raccoon holding a bookmark that says _I love to read_240":"Little raccoon holding a bookmark that says _I love to read_",
            "Minimal sculpture of word _this is the future_ made from light metallic iridescent chrome thin wire, 3-D 20 render, isom205":"Minimal sculpture of word _this is the future_ made from light metallic iridescent chrome thin wire, 3-D 20 render, isometric perspective, ultra-detailed, dark background.",
            "On the campus, a sign that reads _No littering_30":"On the campus, a sign that reads _No littering_",
            "photo of a sign with _one way_14":"photo of a sign with _one way_",
            "There is a _Do Not Disturb_ sign in the hotel81":"There is a _Do Not Disturb_ sign in the hotel",
            "T-shirt with the word _Dream_ printed on it42":"T-shirt with the word _Dream_ printed on it",
          },
          modelDesignsText:"",
          textApproach:"Here is an overview of our overall design method. a, b, and c show the method of constructing quintuple data, which is divided into three steps. d shows traning strategy."
          +"a) Use the large language model ChatGPT to input the original description of the image and the matching instructions, and give the edited description and target description according to the logic of the thinking chain. "
          +"b) Use Controlnet, which can support multiple conditional modes, to input target description and set different scale coefficients to generate target images. "
          +"c) Filter and screen the data from the first and second steps to obtain the final quintuple dataset. "
          +"d) is the training mode we propose, which adds image reconstruction Loss and a mixture-of-expert model to achieve image manipulation guided by arbitrary text."
        };
      },
   mounted() {
    // eslint-disable-next-line no-unused-vars
    let script = require("busuanzi.pure.js");
    window.addEventListener("scroll", this.scrolling);
    // this.initImgList()
     },
  methods: {
    paperClick(){
      window.open('https://arxiv.org/abs/2309.04372', '_blank')
    },
    // initImgList(){
    //   let routeImgs = require.context("@/assets/part1", false);
    //     this.imgsArr = []
    //     routeImgs.keys().forEach(item => {
    //       import("@/assets/part1" + item.replace(".", ""));
    //       this.imgPart1.push({"url":require("@/assets/part1" + item.replace(".", "")),"info":item.replace("./", "").split('.')[0],
    //       "info2":this.infoMap[item.replace("./", "").split('.')[0]]})
    //     });
    //   routeImgs = require.context("@/assets/part2", false);
    //     this.imgsArr = []
    //     routeImgs.keys().forEach(item => {
    //       import("@/assets/part2" + item.replace(".", ""));
    //       this.imgPart2.push({"url":require("@/assets/part2" + item.replace(".", "")),"info":item.replace("./", "").split('.')[0],
    //       "info2":this.infoMap[item.replace("./", "").split('.')[0]]})
    //     });

    //     routeImgs = require.context("@/assets/en_0", false);
    //     this.imgsArr = []
    //     routeImgs.keys().forEach(item => {
    //       import("@/assets/en_0" + item.replace(".", ""));
    //       this.imgPart1.push({"url":require("@/assets/en_0" + item.replace(".", "")),"info":"",
    //       "info2":this.infoMap[item.replace("./", "").split('.')[0]].replaceAll('_','"')})
    //     });

    //     routeImgs = require.context("@/assets/en_1", false);
    //     this.imgsArr = []
    //     routeImgs.keys().forEach(item => {
    //       import("@/assets/en_1" + item.replace(".", ""));
    //       this.imgPart2.push({"url":require("@/assets/en_1" + item.replace(".", "")),"info":"",
    //       "info2":this.infoMap[item.replace("./", "").split('.')[0]].replaceAll('_','"')})
    //     });
    // },

    scrolling() {
      // 滚动条距文档顶部的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // // 滚动条滚动的距离
      // let scrollStep = scrollTop - this.oldScrollTop;
      // console.log("header 滚动距离 ", scrollTop);
      // // 更新——滚动前，滚动条距文档顶部的距离
      // this.oldScrollTop = scrollTop;

      //变量windowHeight是可视区的高度
      // let windowHeight =
      //   document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
        // console.log(scrollTop/scrollHeight);
      if(scrollTop/scrollHeight > 0.70){
        this.getData()
      }
      //滚动条到底部的条件
      // if (scrollTop + windowHeight == scrollHeight) {
      //   //你想做的事情
        
      //   this.getData()
      // }
      // if (scrollStep < 0) {
      //   console.log("header 滚动条向上滚动了！");
      // } else {
      //   console.log("header  滚动条向下滚动了！");
      // }
      // // 判断是否到了最顶部
      // if (scrollTop <= 0) {
      //   console.log("header 到了最顶部")
      // } 
    },
    getData(){
      this.loading = true;
      this.imgsArrDisplay = this.imgsArrDisplay.concat(this.imgsArr.slice(this.sliceIndex-50,this.sliceIndex));
        this.sliceIndex +=50
        console.log(this.imgsArrDisplay.length)
      this.loading = false;
    },
    loadmore() {
      this.loading = true;
      setTimeout(() => {
        this.imgsArrDisplay = this.imgsArrDisplay.concat(this.imgsArr.slice(this.sliceIndex-50,this.sliceIndex));
        this.sliceIndex +=50
        this.loading = false;
        console.log(this.imgsArrDisplay.length)
      }, 1000);
    },
    scrollFn(){
      // this.$nextTick(() => {
      //   console.log("滚了")
      // this.componentKey += 1;
      //       })

    },
    imgClick(index){
      console.log(index)
      this.$viewer.full()
      this.viewer.view(index)
    },
    inited (viewer) {
        this.$viewer = viewer
        this.viewer = viewer
        
      },
    selectChange(val){
      console.log(val)
    },
    onSubmit(){
      this.loading = true
      axios({
            method: "post",
            url: "/api/rongzhi-topic-image/topic-image/analysis/text/list",
            data: JSON.stringify({'tab': this.selectTab,'query':this.inputQuery,'topk':2000}),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
                  }
            }).then(resp => {
              console.log(resp)
          if (resp.data.code == 200) {
            this.imgsArr = []
            this.swiperImageList1 = []
            this.imgsArrDisplay = []
            this.sliceIndex = 50
            for(var item of resp.data.data){
                  if(item['id'] != -1) {
                    this.imgsArr.push({"url":item['url'],"info":item['distance'],"id":item['id']})
                    this.swiperImageList1.push(item['url'])
                  }

                }
                this.getData()
            this.$nextTick(() => {
              
              // this.loadmore()
              })

          }
          else {
            this.$message({
            showClose: true,
            message: resp.data.msg,
            type: 'error'
            });
            this.loading = false
          }
          this.loading = false
            })
    },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .el-select .el-input {
    width: 130px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
.content{
  width: 1000px;margin: 0px auto;
  padding: 10px 25px;
  
}
.el-card{
  border-radius: 15px;
}
.code-paper-button{
  background: #000000;
  border: #000000;
}
.code-paper-button:hover {
  background-color: #0000009e;
}
</style>
